import React, { useEffect, useState, useMemo, useCallback } from "react";
import { THEME_DICTIONARY, ACCEPTED_THEMES } from "consts";
//
import {
    ThemeProvider,
    useMediaQuery,
} from "@material-ui/core";
//
import { SelectedThemeContext } from "theme/themeContext";
import { lightTheme } from "theme/lightTheme";
import { darkTheme } from "theme/darkTheme";

function ThemeWrapper({ children }) {
    const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)", { noSsr: true });
    const userSavedTheme = localStorage.getItem("theme");
    const getThemePreference = useCallback(() => {
        if (userSavedTheme && ACCEPTED_THEMES.includes(userSavedTheme)) {
            return userSavedTheme;
        } else {
            return prefersDarkMode ? THEME_DICTIONARY.DARK : THEME_DICTIONARY.LIGHT;
        }
    }, [userSavedTheme, prefersDarkMode]);
    const [selectedTheme, setSelectedTheme] = useState(getThemePreference(prefersDarkMode));
    const theme = selectedTheme === THEME_DICTIONARY.LIGHT ? lightTheme : darkTheme;

    const colorMode = useMemo(
        () => ({
            toggleTheme: () => {
                setSelectedTheme((prevMode) => {
                    const nextMode = prevMode === THEME_DICTIONARY.LIGHT ? THEME_DICTIONARY.DARK : THEME_DICTIONARY.LIGHT;

                    localStorage.setItem("theme", nextMode);
                    return nextMode;
                });
            },
        }),
        []
    );

    useEffect(() => {
        const themePreference = getThemePreference(prefersDarkMode);
        const htmlTag = document.documentElement;

        setSelectedTheme(themePreference);
        htmlTag.className = `theme-${themePreference}`;
    }, [prefersDarkMode, userSavedTheme, getThemePreference]);

    return (
        <SelectedThemeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </SelectedThemeContext.Provider>
    );
}

export default ThemeWrapper;
